import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  submitSensitiveGoods: new analytics.Event({
    name: 'Sensitive goods question answered',
    description: 'Merchant answers question whether they sell sensitive goods',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['sellsSensitiveGoods'],
    userAttributes: ['sellsSensitiveGoods'],
  }),
  linkClicked: new analytics.Event({
    name: 'Ethic Policy Link Clicked',
    description: 'Merchant clicks on an ethic policy link',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
    userAttributes: [],
  }),
};
